/* Netpeak CRO, 23.09.2026 — zachowanie nowych bloków karty dywaników (grey).
   P16: podgląd pełnoekranowy „Zdjęcia od klientów” (<dialog>, strzałki, klawiatura, przesunięcie palcem). */
(function () {
  'use strict';

  function initUgc(root) {
    if (!root || root.dataset.evmNpReady) return;
    root.dataset.evmNpReady = '1';
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-evm-np-ugc-open]'));
    var dlg = root.querySelector('[data-evm-np-lb]');
    if (!thumbs.length || !dlg || typeof dlg.showModal !== 'function') return;
    /* <dialog> wewnątrz przewijanej karty galerii dziedziczy jej transformacje — przenosimy go do <body>. */
    document.body.appendChild(dlg);
    var img = dlg.querySelector('.evm-np-lb__img');
    var cap = dlg.querySelector('[data-evm-np-lb-cap]');
    var count = dlg.querySelector('[data-evm-np-lb-count]');
    var prev = dlg.querySelector('[data-evm-np-lb-step="-1"]');
    var next = dlg.querySelector('[data-evm-np-lb-step="1"]');
    var quote = dlg.querySelector('[data-evm-np-lb-quote]');
    var items = thumbs.map(function (b) { return { full: b.getAttribute('data-full'), cap: b.getAttribute('data-cap') || '', quote: b.getAttribute('data-quote') || '' }; });
    var idx = 0;
    var opener = null;

    function show(i) {
      idx = Math.max(0, Math.min(items.length - 1, i));
      var it = items[idx];
      img.src = it.full;
      img.alt = it.cap;
      cap.textContent = it.cap;
      count.textContent = (idx + 1) + ' / ' + items.length;
      if (quote) {
        quote.textContent = it.quote ? '„' + it.quote + '”' : '';
        quote.hidden = !it.quote;
      }
      prev.disabled = idx === 0;
      next.disabled = idx === items.length - 1;
      [idx - 1, idx + 1].forEach(function (j) {
        if (j >= 0 && j < items.length) { var pre = new Image(); pre.src = items[j].full; }
      });
    }
    function open(i, from) {
      opener = from || null;
      show(i);
      document.documentElement.classList.add('evm-np-lb-open');
      dlg.showModal();
    }
    function close() {
      if (dlg.open) dlg.close();
    }
    dlg.addEventListener('close', function () {
      document.documentElement.classList.remove('evm-np-lb-open');
      if (opener && opener.focus) opener.focus();
    });
    thumbs.forEach(function (b) {
      b.addEventListener('click', function () { open(parseInt(b.getAttribute('data-evm-np-ugc-open'), 10) || 0, b); });
    });
    prev.addEventListener('click', function () { show(idx - 1); });
    next.addEventListener('click', function () { show(idx + 1); });
    dlg.querySelector('[data-evm-np-lb-close]').addEventListener('click', close);
    /* klik w tło (poza zdjęciem i przyciskami) zamyka */
    dlg.addEventListener('click', function (e) {
      if (e.target === dlg || e.target.classList.contains('evm-np-lb__frame')) close();
    });
    dlg.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); show(idx - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); show(idx + 1); }
    });
    var x0 = null;
    dlg.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    dlg.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      x0 = null;
      if (Math.abs(dx) > 45) show(idx + (dx < 0 ? 1 : -1));
    }, { passive: true });
  }

  /* P8 (24.09): ocena Google przy cenie → ta sama droga co zakładka „Opinie” menu sekcji (ona zna wysokość
     przyklejonego nagłówka i menu). Bez zakładki — przewinięcie do ściany opinii; bez ściany — link do Map Google. */
  function initRate() {
    document.addEventListener('click', function (e) {
      var link = e.target && e.target.closest ? e.target.closest('[data-evm-np-rate]') : null;
      if (!link || e.defaultPrevented || e.button > 0 || e.metaKey || e.ctrlKey || e.shiftKey) return;
      var tab = document.querySelector('.evm-tabs [data-evm-tab="opinie"]');
      if (tab) {
        e.preventDefault();
        tab.click();
        return;
      }
      var wall = document.querySelector('[data-evm-deferred-reviews]');
      if (!wall) return;
      e.preventDefault();
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      (wall.closest('.shopify-section') || wall).scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    });
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-evm-np-ugc]'), initUgc);
    if (document.querySelector('[data-evm-np-rate]')) initRate();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
